exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".i18n-wrap[data-v-ceccf620]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:16px;overflow-x:hidden}.i18n-left[data-v-ceccf620],.i18n-right[data-v-ceccf620]{width:calc(50% - 8px);min-width:0;max-height:68vh;overflow:auto;border:1px solid #ebeef5;border-radius:6px;padding:12px;-webkit-box-sizing:border-box;box-sizing:border-box}.empty-tip[data-v-ceccf620]{text-align:center;color:#909399;margin:20px 0}", ""]);

// exports
